import { uniqBy } from 'lodash';
import type { ICCAsset, IThemeRes } from 'src/interfaces';

export const findUniqueThemes = (ccAssets: ICCAsset[]): IThemeRes[] => {
  const allThemes = ccAssets.flatMap((asset) => asset.themes ?? []);

  const uniqueThemes = uniqBy(allThemes, 'id').concat([
    {
      name: 'No theme',
      id: 0,
      config: {} as any,
      created_at: '',
      modified_at: '',
    },
  ]);

  return uniqueThemes;
};
